import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@/routes/utils";

const baseRoute = `/user-management/student`;

export const studentsRoutesObj = {
  create: `${baseRoute}/create`,
  edit: `${baseRoute}/edit/:studentId`,
} as const;

export type IStudentsRouteParams = IExtractRouteParamMap<
  typeof studentsRoutesObj
>;

export const studentsPath = createPaths<
  typeof studentsRoutesObj,
  IStudentsRouteParams
>(studentsRoutesObj);
